import React, { useMemo } from "react";
import IconFont from "@/components/icon";
import "./index.less";
import classNames from "classnames";
import { duccConfigI18 } from "@/utils/i18n";
import colors from "@/components/styles/colors";
import { connect } from "dva";
import { Tooltip, message, Dropdown } from "antd";
import { TooltipPlacement } from "antd/lib/tooltip";
import { addCustomAppConfig } from "@/api/chat";
import ChatState from "@/types/chat/State";
import { Employee, Session, SessionType } from "@/types/chat";
import ImService from "@/server/ImService";
import Bus from "@/utils/bus";
import { sessionSetting } from "@/server/im/SessionService";
import { SessionSettingsType } from "@/types/chat/enum";
import { changeEgovUrl } from "@/utils/tools";
import ToolsItem from "../ToolsItem";

interface IProps {
  toolsItem: Session;
  isDragAble?: boolean;
  isMine: boolean;
  provided?: any;
  droppableId: string;
  handleToolsItemClick: Function;
  index: number;
  isDragging?: boolean;
  customAppList: Session[];
  updateCustomAppList: Function;
  selectedSession: Session;
  currentEmployee: Employee;
  length: number;
  setLoading: Function;
  handleOk: Function;
  selectedTabList: any[];
  onAppToggle: Function;
}

function DragableToolsItem(props: IProps) {
  const {
    toolsItem,
    isDragAble,
    isMine,
    provided = {},
    droppableId,
    handleToolsItemClick,
    index,
    isDragging,
    currentEmployee,
    length,
    setLoading,
    handleOk,
    selectedTabList,
    onAppToggle
  } = props;
  const handleItemToggle = () => {
    if (isDragAble) {
      handleToolsItemClick(
        droppableId,
        provided.dragHandleProps["data-rbd-drag-handle-draggable-id"]
      );
    }
  };

  const computedIconFont = useMemo(() => {
    if (isDragAble) {
      return isMine ? (
        <IconFont type="iconjs_ic_refuse" style={{ color: "#FC3E32" }} />
      ) : (
        <IconFont type="iconjs_ic_new1" style={{ color: `${colors.primary2}` }} />
      );
    }
    return <IconFont type="iconjs_ic_refuse" style={{ color: "#E8EBEC" }} />;
  }, [isDragAble, isMine]);

  function getClstag() {
    if (isDragAble) {
      return `pageclick|keycount|Xtbg_Msg_AI|${isMine ? "Filter_Delete" : "Filter_Add"}`;
    } else {
      return undefined;
    }
  }

  const toolsIconTipProps: { placement: TooltipPlacement; title: string } = useMemo(() => {
    return {
      placement: droppableId === "mine" ? "bottom" : "top",
      title: droppableId === "mine" ? "移除展示" : "加入展示"
    };
  }, [droppableId]);

  const handleAdd = async () => {
    const imService = ImService.getInstance();
    setLoading(true);
    const session = await imService.getSingleSession(
      {
        app: toolsItem.uid?.app || "dd.notice",
        userId: toolsItem.uid?.pin,
        teamId: toolsItem.uid?.teamId || "focus.bot"
      } as any,
      {
        ...currentEmployee,
        pin: currentEmployee.userId
      },
      SessionType.NOTICE
    );
    if (session) {
      addCustomAppConfig({
        appKey: (toolsItem.info as Employee).userId,
        appName: toolsItem.name
      })
        .then(async (res) => {
          if (res) {
            (session as any).isCustomApp = true;
            const tabList = [...selectedTabList];
            const index = tabList.findIndex((item) => item.pin === toolsItem.uid?.pin);
            if (index > -1) {
              tabList.splice(index, 1);
              handleOk(tabList, "custom");
            }
            sessionSetting(SessionSettingsType.SHIELD, (session as any).sessionId, false);
            sessionSetting(SessionSettingsType.TOP, (session as any).sessionId, false);
            Bus.emit("chat:session-update", session);
          }
        })
        .catch((err) => {
          console.log("err=>", err);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  };

  const handleToggleClick = (type: string, item: any) => {
    onAppToggle(type, item, isMine);
  };

  return (
    <ToolsItem {...props} onAppToggle={handleToggleClick}>
      <IconFont
        type="icona-3biaoqian"
        style={{ color: "#BFC1C4", fontSize: "12px", marginRight: "4px", cursor: "move" }}
      />
      <Tooltip placement={toolsIconTipProps.placement} title={toolsIconTipProps.title}>
        <span className="tools-icon" onClick={handleItemToggle} clstag={getClstag()}>
          {computedIconFont}
        </span>
      </Tooltip>
    </ToolsItem>
  );
}

function mapStateToProps({ chat }: any) {
  const { customAppList, selectedSession, currentEmployee } = chat as ChatState;
  return {
    customAppList,
    selectedSession,
    currentEmployee
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    updateCustomAppList: (payload: any) => {
      dispatch({ type: "chat/updateCustomAppList", payload });
    },
    async updateFilterTabList(data: { filterTabList: any[] }) {
      await dispatch({ type: "chat/updateFilterTabList", payload: data });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DragableToolsItem);
